import { useMemo, useState } from "react";
import dayjs from "dayjs";
import { statusInfo } from "./statusDespesaRecorrente";
import { formatarMoeda, formatarData } from "../../../utils/solicitacoes/formatters";

const ABAS = [
    { key: "pendentes", label: "Pendentes" },
    { key: "proximas", label: "Próximas" },
    { key: "enviadas", label: "Enviadas" },
    { key: "atrasadas", label: "Atrasadas" },
    { key: "marcadas", label: "Marcadas manualmente" },
];

export default function ListaPendenciasDespesasRecorrentes({ ocorrencias, onSelecionar }) {
    const [abaAtiva, setAbaAtiva] = useState("pendentes");

    const grupos = useMemo(() => {
        const hoje = dayjs().format("YYYY-MM-DD");
        const emSeteDias = dayjs().add(7, "day").format("YYYY-MM-DD");
        const lista = ocorrencias || [];
        return {
            pendentes: lista.filter(o => o.status === "PENDENTE" && o.dataLancamentoProgramada <= emSeteDias),
            proximas: lista.filter(o => o.status === "PENDENTE" && o.dataLancamentoProgramada > emSeteDias),
            enviadas: lista.filter(o => o.status === "ENVIADO"),
            atrasadas: lista.filter(o => o.status === "ATRASADO"),
            marcadas: lista.filter(o => o.status === "MARCADO_MANUALMENTE"),
        };
    }, [ocorrencias]);

    const itensAba = grupos[abaAtiva] || [];

    return (
        <div className="bg-card border border-border rounded-lg shadow-card">
            <div className="flex items-center gap-1 overflow-x-auto border-b border-border px-2">
                {ABAS.map(aba => (
                    <button
                        key={aba.key}
                        type="button"
                        onClick={() => setAbaAtiva(aba.key)}
                        className={`px-3 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                            abaAtiva === aba.key
                                ? "border-primary text-primary"
                                : "border-transparent text-muted-foreground hover:text-foreground"
                        }`}
                    >
                        {aba.label} <span className="text-xs text-muted-foreground">({grupos[aba.key]?.length ?? 0})</span>
                    </button>
                ))}
            </div>

            <div className="divide-y divide-border">
                {itensAba.length === 0 && (
                    <div className="px-4 py-10 text-center text-sm text-muted-foreground">Nenhuma despesa recorrente nesta categoria.</div>
                )}
                {itensAba.map(o => {
                    const cfg = statusInfo(o.status);
                    return (
                        <button
                            key={o.id}
                            type="button"
                            onClick={() => onSelecionar(o)}
                            className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-muted/40 transition-colors"
                        >
                            <span className={`w-2.5 h-2.5 rounded-full shrink-0 ${cfg.dot}`} />
                            <div className="flex-1 min-w-0">
                                <div className="text-sm font-medium text-foreground truncate">{o.descricao}</div>
                                <div className="text-xs text-muted-foreground truncate">
                                    {o.fornecedorNome || "-"} {o.filialNome ? `— ${o.filialNome}` : ""}
                                </div>
                            </div>
                            <div className="text-right shrink-0">
                                <div className="text-sm text-foreground">{formatarMoeda(o.valorPrevisto)}</div>
                                <div className="text-xs text-muted-foreground">Venc. {formatarData(o.dataVencimentoProgramada)}</div>
                            </div>
                            <span className={`text-xs font-medium px-2 py-0.5 rounded-full shrink-0 ${cfg.badge}`}>{cfg.emoji} {cfg.label}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
